import { DELIVERY_VOUCHERS_PERMISSIONS } from 'constants/delivery-vouchers';

export const BASE_TRACKING_V2_PATH = 'inbound/notas-fiscais';

export const TRACKING_V2_ROUTES = {
  invoicesTracking: () => ({
    path: `tracking` as const,
    url: `/${BASE_TRACKING_V2_PATH}/tracking` as const,
  }),
  invoiceDetails: (invoiceId?: string | number) => ({
    path: `invoice/:id` as const,
    url: `/${BASE_TRACKING_V2_PATH}/invoice/${invoiceId}` as const,
  }),
  tripsTracking: () => ({
    path: `trips` as const,
    url: `/${BASE_TRACKING_V2_PATH}/trips` as const,
  }),
  createTrip: () => ({
    path: `trips/new` as const,
    url: `/${BASE_TRACKING_V2_PATH}/trips/new` as const,
  }),
  deliveryVouchers: () => ({
    path: `comprovantes` as const,
    url: `/${BASE_TRACKING_V2_PATH}/comprovantes` as const,
    permissions: DELIVERY_VOUCHERS_PERMISSIONS.index,
  }),
  tripDetails: (tripId?: string | number) => ({
    path: `trips/:id` as const,
    url: `/${BASE_TRACKING_V2_PATH}/trips/${tripId}` as const,
  }),
};

export const BASE_SCHEDULED_REPORTS_PATH = 'relatorios';

export const SCHEDULED_REPORTS_ROUTES = {
  invoicesTracking: () => ({
    path: `notas-fiscais` as const,
    url: `/${BASE_SCHEDULED_REPORTS_PATH}/notas-fiscais` as const,
  }),
  tripsTracking: () => ({
    path: `trips` as const,
    url: `/${BASE_SCHEDULED_REPORTS_PATH}/trips` as const,
  }),
  inventoryDailyItemsIntegral: () => ({
    path: `inventario` as const,
    url: `/${BASE_SCHEDULED_REPORTS_PATH}/inventario` as const,
  }),
  viagensBilling: () => ({
    path: `viagens-faturar` as const,
    url: `/${BASE_SCHEDULED_REPORTS_PATH}/viagens-faturar` as const,
    permissions: ['ACCESS_VIAGENS_CONTROLE'],
  }),
};

export const BASE_TEMPERATURE_CONTROL_PATH = 'temperature-control';

export const TEMPERATURE_CONTROL_ROUTES = {
  list: () => ({
    path: '' as const,
    url: `/${BASE_TEMPERATURE_CONTROL_PATH}` as const,
    permissions: ['TEMPERATURE_CONTROL.FETCH'],
  }),
  listEquipments: () => ({
    path: 'equipment/list' as const,
    url: `/${BASE_TEMPERATURE_CONTROL_PATH}/equipment/list` as const,
    permissions: ['TEMPERATURE_CONTROL.EQUIPMENT.LIST'],
  }),
};

export const BASE_VIAGENS_CONTROLE_PATH = 'viagens-controle';

export const VIAGENS_CONTROLE_ROUTES = {
  monitoring: () => ({
    path: 'acompanhamento' as const,
    url: `/${BASE_VIAGENS_CONTROLE_PATH}/acompanhamento` as const,
  }),
  list: () => ({
    path: '' as const,
    url: `/${BASE_VIAGENS_CONTROLE_PATH}` as const,
  }),
  approvals: () => ({
    path: 'aprovacoes' as const,
    url: `/${BASE_VIAGENS_CONTROLE_PATH}/aprovacoes` as const,
  }),
  billings: () => ({
    path: 'faturas' as const,
    url: `/${BASE_VIAGENS_CONTROLE_PATH}/faturas` as const,
  }),
  createBilling: () => ({
    path: 'faturas/nova' as const,
    url: `/${BASE_VIAGENS_CONTROLE_PATH}/faturas/nova` as const,
  }),
};

export const BASE_INVENTORY_2_PATH = 'inventory-2';

export const INVENTORY_2_ROUTES = {
  importFiles: () => ({
    path: '' as const,
    url: `/${BASE_INVENTORY_2_PATH}` as const,
  }),
};

export const BASE_RESTRICTED_PRODUCTS_PATH = 'produtos-restritos';

export const RESTRICTED_PRODUCTS_ROUTES = {
  list: () => ({
    path: '' as const,
    url: `/${BASE_RESTRICTED_PRODUCTS_PATH}` as const,
    permissions: ['RES.RESTRICTEDMATERIALS.LISTEVENTS'],
  }),
  importFiles: () => ({
    path: `importar` as const,
    url: `/${BASE_RESTRICTED_PRODUCTS_PATH}/importar` as const,
  }),
};
